import { render, staticRenderFns } from "./ProposalSubmitted.vue?vue&type=template&id=1409f023&"
import script from "./ProposalSubmitted.vue?vue&type=script&lang=js&"
export * from "./ProposalSubmitted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports